module.exports = __webpack_public_path__ + "img/33.8ee39e15.png";